module.exports = __webpack_public_path__ + "img/dashboard-icon-dark.6115d4ba.svg";